import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/AssetLabelling/state';

export const useVisibleCuboids = () => {
  const allCuboids = useAtomValue(state.cuboids);
  const cuboidClassById = useAtomValue(state.cuboidClassById);

  const visibleCuboids = useMemo(
    () =>
      allCuboids.filterValues((value) => cuboidClassById?.[value.cuboidClassId].isVisible ?? true),
    [allCuboids, cuboidClassById]
  );

  return visibleCuboids;
};
